import { createContext, useContext, type ReactNode } from 'react'
import type { BaseMapInfo, OverlayInfo } from './MapLayersPicker'

export interface MapCatalogue {
  baseMaps: BaseMapInfo[]
  overlayMaps: OverlayInfo[]
  url?: string
  generation?: number
  widths?: number[]
  minZ?: number
  maxZ?: number
}
export interface MapCatalogueState {
  data: MapCatalogue | null
  pending: boolean
  error: boolean
  retry?: () => void
}
const MapCatalogueContext = createContext<MapCatalogueState>({
  data: null,
  pending: true,
  error: false,
})

/** Catalogue ownership and authenticated fetching belong to the host. */
export function MapCatalogueProvider({
  value,
  children,
}: {
  value: MapCatalogueState
  children: ReactNode
}) {
  return (
    <MapCatalogueContext.Provider value={value}>
      {children}
    </MapCatalogueContext.Provider>
  )
}
export const useMapCatalogue = () => useContext(MapCatalogueContext)
